import { gambits, localize } from '@/core/gambits';
import type { PlayedPrompt } from '@/views/main/handshakes/utils/played-prompt';

/** Yes has written the position, so the photos taken for it leave the handshake and join it. */
export async function assignPlayedPhotos(prompt: PlayedPrompt): Promise<string | null> {
  for (const hash of prompt.photos ?? []) {
    const moved = await gambits.userService.moveHandshakeImage(prompt.handshakeId, hash, prompt.position);
    if (moved.error) return moved.error.message || localize('handshake.photo.failed');
  }

  return null;
}
